import { render } from "./BlogInOnLaysHurt.vue?vue&type=template&id=2caf2300"
import script from "./BlogInOnLaysHurt.vue?vue&type=script&lang=js"
export * from "./BlogInOnLaysHurt.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__